###
Shared code used to render line items in carts
###
import NumberStepper from 'library/components/globals/form/number-stepper'
import RadioList from 'library/components/globals/form/radio-list'
import debounce from 'lodash/debounce'
export default

	props:
		item: Object

	components: {
		NumberStepper
		RadioList
	}

	data: ->
		quantity: @item.quantity
		loading: false
		isSubscribing: !!@item?.sellingPlanAllocation
		sellingPlanId:
			if @item.sellingPlanAllocation
				@item.sellingPlanAllocation.sellingPlan.id
			else
				@item?.variant?.sellingPlanAllocations?[0]?.sellingPlan?.id

	computed:

		# Does this line have a subscription
		hasSubscription: -> !!@item?.sellingPlanAllocation

		currentVariant: -> @item?.variant

		primarySellingPlans: -> @currentVariant?.sellingPlanAllocations

		lineItemTotal: -> @item.cost.subtotalAmount.amount

		attrs: -> @item.customAttributes

		classes: -> 'is-loading' if @loading

		# Get the product type
		productType: -> @currentVariant.product.productType

		# Make the URL progromatically. Don't make a URL if a free sample, it's
		# assumed these shouldn't have PDPs.
		url: ->
			return if @currentVariant.id in
				@$store.getters['free-gift/choice/variantIds']
			return if @currentVariant.product.handle in
				@$store.getters['free-gift/automatic/handles']
			'/products/' + @currentVariant.product.handle

		# Make a clean object to prevent errors about mutating object
		image: -> @currentVariant.image

		subscriptionOptions: ->
			@item?.variant?.sellingPlanAllocations.map ({sellingPlan, priceAdjustments}) -> {
				value: sellingPlan.id
				label: sellingPlan.name
			}

		# Build the payload for updating the cart line, for introspection
		updateLinePayload: ->
			id: @item.id
			quantity: @quantity
			sellingPlanId: if @isSubscribing then @sellingPlanId else null
			attributes: @item?.attributes

		# Helper for getting the current price
		price: -> @currentVariant.price.amount

		# Lookup the selected sellingPlanId
		sellingPlanAllocation: ->
			@primarySellingPlans.find (allocation) =>
				allocation.sellingPlan.id == @sellingPlanId

		# Calculate the discount percentage based on the chosen selling plan
		subscriptionDiscount: ->
			return unless @subscriptionPrice
			Math.round(100 * (1 - @subscriptionPrice / @price)) + '%'

		# Get the discounted price based on the chosen selling plan
		subscriptionPrice: ->
			@sellingPlanAllocation?.priceAdjustments[0]?.price.amount

		# Is this a free product?
		isFree: -> parseFloat(@item.variant.price.amount) == 0

		# Gifting details
		isGift: -> !!@item?.attributes?.find ({key, value}) ->
			key == "__shopify_send_gift_card_to_recipient" and value == 'on'

		giftTitle: ->
			recipientEmail = (@item?.attributes?.find ({key, value}) ->
				key == "Recipient email").value
			return "Sending to: #{recipientEmail}"

	watch:

		# Trigger updating of the cart on a debounce
		quantity: (val,old) -> @debouncedUpdate val, old

		# Trigger updating of the cart on a debounce
		sellingPlanId: (val,old) -> @debouncedUpdate val, old

		isSubscribing: (val,old) -> @debouncedUpdate val, old

		# Update the internal quantity if something else has touched it
		'item.quantity': (val) -> @quantity = val

	methods:
		# Trigger updating of the cart on a debounce
		debouncedUpdate: debounce (val, old) ->
			@loading = true
			await @$store.dispatch 'cart/updateLine', @updateLinePayload
			@loading = false
		, 300
